import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { filter, map, Observable } from 'rxjs';
import { ApplicationContextService } from 'src/app/services/application-context.service';

@Injectable({
  providedIn: 'root'
})
export class CanActivateCommandCenterGuard {

  constructor(private readonly _applicationContextService: ApplicationContextService,
    private readonly _router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this._applicationContextService.context.pipe(
      filter(context => !!context?.currentlyLoggedInUserProfile?.userProfile),
      map(context => {
        if (context.currentlyLoggedInUserProfile?.userProfile?.companyId != 2) {
          this._router.navigateByUrl('admin/dashboardv2');
          return false;
        }
        return true;
      })
    );
  }
}
